import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { TreeSelect } from 'antd';
import TaskTypes from 'Constants/TaskTypes';
import { useLanguage } from 'Context/LanguageContext';
import { Box, Typography } from '@mui/material';

const SelectTaskType = forwardRef(
  ({ selectedType, taskTypeOptions, updateTaskType, dontUseMargin }, ref) => {
    const lan = useLanguage();
    const INITIAL_TASK_TYPES = [
      {
        id: TaskTypes.PICKUP,
        name: lan.pickup,
        children: [],
        title: lan.pickup,
        value: TaskTypes.PICKUP,
        key: TaskTypes.PICKUP,
      },
      {
        id: TaskTypes.WORKFORCE,
        name: lan.workforce,
        children: [],
        title: lan.workforce,
        value: TaskTypes.WORKFORCE,
        key: TaskTypes.WORKFORCE,
      },
      {
        id: TaskTypes.DELIVERY,
        name: lan.delivery,
        children: [],
        title: lan.delivery,
        value: TaskTypes.DELIVERY,
        key: TaskTypes.DELIVERY,
      },
      {
        id: TaskTypes.REMOTE,
        name: lan.remote,
        children: [],
        title: lan.remote,
        value: TaskTypes.REMOTE,
        key: TaskTypes.REMOTE,
      },
    ];

    const [taskTypes, setTaskTypes] = useState(INITIAL_TASK_TYPES);
    const [taskTypeList, setTaskTypeList] = useState(INITIAL_TASK_TYPES);

    useImperativeHandle(ref, () => ({
      getSelectedTaskType: () => selectedType,
    }));

    useEffect(() => {
      // keep original logic
      handleChangeTaskType(1);
    }, []);

    useEffect(() => {
      if (taskTypeOptions) {
        for (let i = 0; i < taskTypeOptions.taskTypes.length; i++) {
          if (taskTypeOptions.taskTypes[i].id === TaskTypes.REMOTE) {
            taskTypeOptions.taskTypes[i].title = lan.remote;
          }
        }
        setTaskTypes([...taskTypeOptions.taskTypes]);
        setTaskTypeList(taskTypeOptions.taskTypeList);
      }
    }, [taskTypeOptions, lan]);

    const handleChangeTaskType = (typeId) => {
      const selected = taskTypeList.find((type) => type.id === typeId);
      updateTaskType(selected);
    };
    return (
      <Box sx={{ m: dontUseMargin ? 0 : 3 }}>
        <Typography variant="body2" sx={{ pb: 1 }}>
          {lan.taskType}
        </Typography>
        <Box>
          <TreeSelect
            id="task-type-tree-select"
            treeData={taskTypes}
            onChange={handleChangeTaskType}
            placeholder={lan.taskType}
            dropdownStyle={{ maxHeight: 400, zIndex: 1500, overflow: 'auto' }}
            value={selectedType && taskTypes.length > 0 ? selectedType.id : null}
            size="large"
            getPopupContainer={() => document.body}
            style={{
              width: '100%',
              borderRadius: 10,
            }}
          />
        </Box>
      </Box>
    );
  }
);
export default SelectTaskType;
//Original code:
/*import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { TreeSelect } from 'antd';
import TaskTypes from 'Constants/TaskTypes';
import { useLanguage } from 'Context/LanguageContext';
const SelectTaskType =
  forwardRef(({ selectedType, taskTypeOptions, updateTaskType, dontUseMargin, dontExecuteSelectedAction }, ref) => {
	const lan = useLanguage();
	const INITIAL_TASK_TYPES = [
		{
			id: TaskTypes.PICKUP,
			name: lan.pickup,
			children: [],
			title: lan.pickup,
			value: TaskTypes.PICKUP,
			key: TaskTypes.PICKUP,
		},
		{
			id: TaskTypes.WORKFORCE,
			name: lan.workforce,
			children: [],
			title: lan.workforce,
			value: TaskTypes.WORKFORCE,
			key: TaskTypes.WORKFORCE,
		},
		{
			id: TaskTypes.DELIVERY,
			name: lan.delivery,
			children: [],
			title: lan.delivery,
			value: TaskTypes.DELIVERY,
			key: TaskTypes.DELIVERY,
		},
		{
			id: TaskTypes.REMOTE,
			name: lan.remote,
			children: [],
			title: lan.remote,
			value: TaskTypes.REMOTE,
			key: TaskTypes.REMOTE,
		},
	];
	const [taskTypes, setTaskTypes] = useState(INITIAL_TASK_TYPES);
	const [taskTypeList, setTaskTypeList] = useState(INITIAL_TASK_TYPES);
  useImperativeHandle(ref, () => ({
    getSelectedTaskType: () => selectedType,
  }));
	useEffect(() => {
		if (!dontExecuteSelectedAction) {
			handleChangeTaskType(1);
		}
	}, []);
	useEffect(() => {
		if (taskTypeOptions) {
			for (let i = 0; i < taskTypeOptions.taskTypes.length; i++) {
				if (taskTypeOptions.taskTypes[i].id === TaskTypes.REMOTE) {
					taskTypeOptions.taskTypes[i].title = lan.remote;
				}
			}
			setTaskTypes([...taskTypeOptions.taskTypes]);
			setTaskTypeList(taskTypeOptions.taskTypeList);
		}
	}, [taskTypeOptions]);
	const handleChangeTaskType = (selectedType) => {
		const selected = taskTypeList.find((type) => type.id === selectedType);
		updateTaskType(selected);
	};

	return (
		<div className={dontUseMargin ? '' : 'mx-3 my-3' }>
			<>
				<span className='title-padding text-title'>{lan.taskType}</span>
				<TreeSelect
					id='task-type-tree-select'
					className='full-width border-radius-10'
					treeData={taskTypes}
					popupClassName='taskType-treeSelect'
					onChange={handleChangeTaskType}
					placeholder={lan.taskType}
					value={selectedType && taskTypes.length > 0 ? selectedType.id : null}
					size='large'
          dropdownStyle={{ zIndex: 1500 }}
          getPopupContainer={() => document.body}
				/>
			</>
		</div>
	);
  });
export default SelectTaskType;
*/
